// include all of bootstrap javascript
import 'bootstrap';

// or include just the bits of bootstrap javascript we want
//import 'bootstrap/js/dist/modal';
//import 'bootstrap/js/dist/tooltip';